import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export const getCallReport = (
    tenantId: number,
    fromDate: string,
    toDate: string,
    employeeId?: number | null,
) => {
    const payload: Record<string, any> = { tenant_id: tenantId, from_date: fromDate, to_date: toDate };
    if (employeeId) payload.employee_id = employeeId;
    else payload.show_all = 1;
    return api.post(API_ROUTES.REPORTS.CALL_REPORT, payload);
};

export const getCallReportVisitDetails = (
    tenantId: number,
    visitId: number,
    visitType: "doctor" | "firm",
) => api.post(API_ROUTES.REPORTS.CALL_REPORT_DETAILS, { tenant_id: tenantId, visit_id: visitId, visit_type: visitType });

export const getMissedCallReport = (
    tenantId: number,
    month: string,
    employeeId?: number | null,
) => {
    const payload: Record<string, any> = { tenant_id: tenantId, month };
    if (employeeId) payload.employee_id = employeeId;
    return api.post(API_ROUTES.REPORTS.MISSED_CALL_REPORT, payload);
};

export const getVisitTracker = (
    tenantId: number,
    date: string,
    employeeId?: number | null,
) => {
    const payload: Record<string, any> = { tenant_id: tenantId, date };
    if (employeeId) payload.employee_id = employeeId;
    else payload.show_all = 1;
    return api.post(API_ROUTES.REPORTS.VISIT_TRACKER, payload);
};

export const getAttendanceReport = (
    tenantId: number,
    employeeId: number,
    month: string,
) => api.post(API_ROUTES.REPORTS.ATTENDANCE, { tenant_id: tenantId, employee_id: employeeId, month });

export const getSubordinateAttendance = (
    tenantId: number,
    employeeId: number,
    date?: string | null,
) => {
    const payload: Record<string, any> = { tenant_id: tenantId, employee_id: employeeId };
    if (date) payload.date = date;
    return api.post(API_ROUTES.REPORTS.SUBORDINATE_ATTENDANCE, payload);
};

export const getAllEmployeeAttendance = (
    tenantId: number,
    date?: string | null,
) => {
    const payload: Record<string, any> = { tenant_id: tenantId };
    if (date) payload.date = date;
    return api.post(API_ROUTES.REPORTS.ALL_EMPLOYEE_ATTENDANCE, payload);
};
